import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const REPORT_URL = `report/time`

const getReport = (
  dataInicial: string,
  dataFinal: string,
  nomeColuna: string,
  tipoRelatorio?: string
): Promise<string> => {
  const params = {dataInicial, dataFinal, nomeColuna}

  return axios
    .get(`${API_URL}/${tipoRelatorio}/${REPORT_URL}`, {params})
    .then((d: AxiosResponse<string>) => d.data)
}

export {getReport}
